import Vue from "vue";
import ApiService from "@/common/api.service";
import { API_PATH } from "@/common/config";

const PATH = "stock/product-categories";

export const GET_STOCK_PRODUCT_CATEGORIES = "getStockProductCategories";
export const GET_STOCK_PRODUCT_CATEGORY = "getStockProductCategory";
export const GET_STOCK_PRODUCT_CATEGORY_OPTIONS = "getStockProductCategoryOptions";
export const CREATE_STOCK_PRODUCT_CATEGORY = "createStockProductCategory";
export const UPDATE_STOCK_PRODUCT_CATEGORY = "updateStockProductCategory";
export const DELETE_STOCK_PRODUCT_CATEGORY = "deleteStockProductCategory";

const actions = {
  [GET_STOCK_PRODUCT_CATEGORIES](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(PATH, params)
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_PRODUCT_CATEGORY](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get(PATH, id)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_PRODUCT_CATEGORY_OPTIONS](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${PATH}/options`, params)
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CREATE_STOCK_PRODUCT_CATEGORY](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post(PATH, params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [UPDATE_STOCK_PRODUCT_CATEGORY](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.update(PATH, payload.id, payload.params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [DELETE_STOCK_PRODUCT_CATEGORY](context, id) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .delete(`${API_PATH}${PATH}/${id}`)
        .then(() => resolve(true))
        .catch((error) => reject(error?.response?.data ?? error));
    });
  },
};

export default {
  actions,
};
